<template>
  <div class="d-flex" id="wrapper">
    <ManagerSidebar :toggler.sync="isToggled" />
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getManagerUserProfile" />
      <ManagerProfile />
    </div>
    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import TopNavbar from '@/components/Navigations/TopNavbar';
import ManagerSidebar from '@/components/Navigations/ManagerSidebar';
import ManagerProfile from '@/components/Manager/ManagerProfile';
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';

import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    ManagerSidebar,
    TopNavbar,
    ManagerProfile,
  },
  mixins: [toggleSidebarNav],
  data: () => ({
    isToggled: false,
  }),
  methods: {
    ...mapActions('managerStoreModule', ['retrieveManagerProfile', 'retrieveManagerUserProfile']),
  },
  computed: { ...mapGetters('managerStoreModule', ['getManagerProfile', 'getManagerUserProfile']) },
  mounted() {
    this.retrieveManagerProfile();
    this.retrieveManagerUserProfile();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
</style>
